<div class="svg-icon svg-icon-selected">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="design-iconfont">
    <path
      d="M2 7.84375018L5.95899495 12.3709213 14 3.37092129"
      stroke="#FF7000"
      stroke-width="2"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</div>

<style>
  .svg-icon {
    height: 1em;
    width: 1em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
